
class DavisPreloaderController {
    public isLoadind:   boolean;
    public hasError:     boolean;
    public hasSuccess:   boolean;
    public message:     string;
} 
export class DavisPreloader implements ng.IDirective {
    public restrict = 'E';
	public transclude = true;
	
	public controller = DavisPreloaderController;
    public controllerAs:string = 'davisPreloader';
    
    public scope = {};
    public bindToController = {
        isLoading: '=',
        hasError: '=',
        hasSuccess: '=',
		message: '=?'
    };

	public template = `
        
        <div ng-show="!davisPreloader.isLoading && davisPreloader.hasSuccess" class="alert alert-success m-3 mr-5 p-2" >
            {{ davisPreloader.message}}
        </div>
        
        <div ng-show="!davisPreloader.isLoading && davisPreloader.hasError" class="alert alert-danger m-3 mr-5 p-2" >
            {{ davisPreloader.message}}
        </div>
        
        <div id="preloader" class="spinner-container" ng-show="davisPreloader.isLoading">
            <div id="preloader-status">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ davisPreloader.message }}</span>
                </div>
            </div>
        </div>
        
        <div ng-transclude ng-show="!davisPreloader.isLoading"><!-- content will be injected here --></div>
	`;
	
	public static Factory() {
		return () => new this();
	}
}
